export default __webpack_public_path__ + "static/media/Black Circle.550250b2.svg";